module.exports = __webpack_public_path__ + "5a6c3a8b83a32ff4fb6a394ea2be0c05.png";